export default appLocalizer;
